import moduleInfo from '../module.json';
import type { AppRuntime } from '@ayocore/platform/client/runtime/AppRuntime';
import { IconBrain, IconEye } from '@tabler/icons-react';
import { lazy } from 'react';

/**
 * Бутстрап модуля Tasks (клиент)
 * Регистрирует навигацию через рантайм.
 */
export async function setup(app: AppRuntime) {
  const tasks = app.useModule(moduleInfo.name, {
    version: moduleInfo.version,
    description: moduleInfo.description,
  });

  tasks.useNavigation([
    {
      label: 'Задачи',
      icon: IconBrain,
      url: '/tasks',
      component: lazy(() => import('./components/TasksList')),
    },
    {
      icon: IconEye,
      label: 'Просмотр задачи',
      url: '/tasks/:id',
      component: lazy(() =>
        import('./components/views/TaskViewPage').then(m => ({ default: m.TaskViewPage }))
      ),
      hiddenFromMenu: true, // Don't show in menu since it requires an ID parameter
    },
  ]);
}
